import CustomMessage from "../../../utils/CustomMessage";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import ApiClient from "../../../apiClient";
import { BASE_URL, SEARCH, INSTOREREQUEST } from "../../../constant/apiEndPoint";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getAllRequests = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${INSTOREREQUEST.getAllRequest}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_REQUESTS_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_REQUESTS_FAIL,
          payload: CustomMessage(error.status),
        });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};



export const getFilteredRequestAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${SEARCH.ADMIN_SEARCH}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_REQUESTS_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.GET_ALL_REQUESTS_FAIL, payload: [] });
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const createAcceptReuqestAction = (payload, navigate) => {
    return (dispatch) => {
      loadingToggleAction(dispatch, true);
      ApiClient.post(`${BASE_URL}${INSTOREREQUEST.createAcceptReuqest}`, payload, true)
        .then((response) => {
          loadingToggleAction(dispatch, false);
          dispatch({ type: TYPE.CREATE_ACCEPT_REQUEST_SUCCESS, payload: response?.data });
          CustomToast({
            type: "success",
            message: response.data.result.message,
            options: { autoClose: 3000, position: "top-center" },
          });
          navigate('/redeem_requests')
        })
        .catch((error) => {
          loadingToggleAction(dispatch, false);
          // if (error.status === 419) {
          //   CustomToast({
          //     type: "error",
          //     message: "Session expired, please login again",
          //     options: { autoClose: 5000, position: "top-center" },
          //   });
          //   checkSession(dispatch, navigate);
          //   return;
          // }
          dispatch({ type: TYPE.CREATE_ACCEPT_REQUEST_FAIL, payload: error?.data?.result?.message });
          // CustomToast({
          //   type: "error",
          //   message: error?.data?.result?.message,
          //   options: { autoClose: 5000, position: "top-center" },
          // });
          navigate('/redeem_requests')
        });
    };
  };
